'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactSpinkit = require('react-spinkit');

var _reactSpinkit2 = _interopRequireDefault(_reactSpinkit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BisuReactLoading = function BisuReactLoading(_ref) {
  var name = _ref.name;
  return _react2.default.createElement(
    'div',
    { className: 'bisu--react-loading' },
    _react2.default.createElement(_reactSpinkit2.default, { spinnerName: name, noFadeIn: true })
  );
};

BisuReactLoading.defaultProps = {
  name: 'cube-grid'
};

exports.default = BisuReactLoading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bisu-react-loading/lib/index.js
// module id = 104
// module chunks = 0